import React from 'react';
import { Toaster as SonnerToaster } from 'sonner';
import { useTheme } from '../../hooks/use-theme';

export const BartechToaster: React.FC = () => {
  const { theme } = useTheme();

  return (
    <SonnerToaster
      theme={theme}
      position="top-right"
      richColors={false}
      closeButton
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            'bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-xl shadow-lg p-4 flex gap-3 items-center font-sans',
          title: 'text-sm font-semibold tracking-tight',
          description: 'text-xs text-neutral-500 dark:text-neutral-400',
          actionButton:
            'bg-brand-primary text-white text-xs font-medium px-3 py-1.5 rounded-lg hover:bg-brand-hover transition-colors',
          cancelButton:
            'bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 text-xs px-3 py-1.5 rounded-lg',
          success:
            '!border-emerald-500/40 !bg-emerald-50/70 dark:!bg-emerald-950/30 text-emerald-950 dark:text-emerald-200',
          error:
            '!border-rose-500/40 !bg-rose-50/70 dark:!bg-rose-950/30 text-rose-950 dark:text-rose-200',
          warning:
            '!border-amber-500/40 !bg-amber-50/70 dark:!bg-amber-950/30 text-amber-950 dark:text-amber-200',
          info:
            '!border-sky-500/40 !bg-sky-50/70 dark:!bg-sky-950/30 text-sky-950 dark:text-sky-200',
        },
      }}
    />
  );
};

export const AppToaster = BartechToaster;
